import { LeadDetailRawType } from '../../types/Lead';
import { DocumentType, LeadDocuments } from '../../types/Document';

export default function transformDocumentState(data: LeadDetailRawType): LeadDocuments {
    const onboardingDocFilter = (document: DocumentType) =>
        document?.referenceType !== 'DOCUMENT_TYPE_KYC_SHEET' &&
        document?.referenceType !== 'DOCUMENT_TYPE_UNSIGNED_FLEX_CONTRACT' &&
        document?.referenceType !== 'DOCUMENT_TYPE_UNSIGNED_SEPA_MANDATE';
    const kycFilter = (document: DocumentType) => document?.referenceType === 'DOCUMENT_TYPE_KYC_SHEET';
    const docMapper = (document: DocumentType) => {
        return {
            partner: document.partner,
            aggregateType: document.aggregateType,
            referenceId: document.referenceId,
            referenceType: document.referenceType,
            documentId: document.documentId,
        };
    };
    let optionalKycDoc = data.documents.find(kycFilter);
    let kycDoc = optionalKycDoc ? docMapper(optionalKycDoc) : optionalKycDoc;
    let onboardingDocuments = data.documents.filter(onboardingDocFilter).map(docMapper);

    return {
        kycDocument: kycDoc,
        onboardingFlowDocuments: onboardingDocuments,
    };
}
